import React, { Fragment, SFC } from 'react';
import { compose } from 'recompose';
import styled, { ThemeProps, withTheme } from '../../styled-components';
import ObserveSize from 'react-observe-size';
import gql from 'graphql-tag';
import { DataValue } from 'react-apollo';
import { RouteComponentProps, withRouter } from 'react-router';
import { ExchangeParams } from '../Exchange';
import Container from '../atoms/Container';
import Separator from '../atoms/Separator';
import FooterContact from '../molecules/footer/FooterContact';
import FooterLinks from '../molecules/footer/FooterLinks';
import FooterSocial from '../molecules/footer/FooterSocial';
import { FooterLinkFragment, FooterSocialsFragment, MenuFragment, MenuQuery } from '../../entities/operationResults';
import { getEntriesOfType } from '../../services/entryTypes';
import FooterMenu from '../molecules/footer/FooterMenu';
import { path } from 'ramda';

export const FooterFragments = gql`
    fragment FooterLink on footerLink_footerLink_Entry {
        id
        title
        linkEntry{
            uri
        }
    }
`;

const enhanced = compose<OutProps, InProps>(
    withTheme,
    withRouter,
);

interface InProps {
    data: DataValue<MenuQuery> | null;
}

interface OutProps extends ThemeProps, RouteComponentProps<ExchangeParams> {
}

const Footer: SFC<OutProps & InProps> = ({ data, theme }) => {
    const menuItems: MenuFragment[] | null = getEntriesOfType('menu_menu_Entry', data && data.menuItems);
    const footerLinks: FooterLinkFragment[] | null = getEntriesOfType('footerLink_footerLink_Entry', data && data.footerLinks);
    const socialLinks = path<FooterSocialsFragment>(['globals', 'socialMedia'], data || {});
    const mailChimpUrl = path<string>(['globalSet', 'mailChimpSubscriptionUrl'], data || {});
    const footerContactFormText = path<string>(['globals', 'exchangeConfig', 'footerContactFormText'], data || {});
    const siteHandle = path<string>(['variables', 'site'], data || {});

    return (
        <Fragment>
            <ObserveSize>
                {({ width }) =>
                    <Wrapper>
                        <Container
                            maxWidth
                            paddingTop={'3rem'}
                            paddingTopL={'7.2rem'}
                            paddingBottom={'1rem'}
                            paddingBottomL={'9.5rem'}
                        >
                            <FooterWrap>
                                <FooterContact mailChimpUrl={mailChimpUrl} contactFormText={footerContactFormText} />
                                {width >= theme.mediaQueriesValues.m &&
                                <FooterMenu menuItems={menuItems || []} />
                                }
                            </FooterWrap>
                        </Container>
                            <Separator color={theme.colors.shuttleGray}/>
                        <Container maxWidth paddingTop={'4rem'} paddingTopL={'2rem'} paddingBottom={'2rem'} paddingBottomL={'4rem'}>
                            <FooterWrap className={'small-centered'}>
                            <FooterLinks siteHandle={siteHandle || ''} footerLinks={footerLinks || []}/>
                            <FooterSocial socialLinks={socialLinks}/>
                            </FooterWrap>
                        </Container>
                    </Wrapper>
                }
            </ObserveSize>
        </Fragment>
    );
};

const Wrapper = styled.div`
    position: relative;
    z-index: 10;
    background-color: ${props => props.theme.colors.black};
`;

const FooterWrap = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  &.small-centered  {
    text-align: center;
    flex-direction: column;
    @media screen and (min-width: ${(props) => props.theme.mediaQueries.m}) {
      text-align: left;
      flex-direction: row;
    }
  }
`;

export default enhanced(Footer);